import { Link } from "react-router-dom";
import { Instagram, Phone } from "lucide-react";
import { useCategories } from "../lib/hooks";
import { INSTAGRAM_URL, INSTAGRAM_HANDLE, WHATSAPP_URL, WHATSAPP_NUMBER } from "../lib/api";

const LEGAL = [
  ["/livraison-retours", "Livraison et retours"],
  ["/cgv", "Conditions générales de vente"],
  ["/retractation", "Rétractation et remboursements"],
  ["/mentions-legales", "Mentions légales"],
  ["/confidentialite", "Politique de confidentialité"],
  ["/cookies", "Gestion des cookies"],
];

export const Footer = () => {
  const cats = useCategories();
  return (
    <footer className="relative bg-[#070707] border-t border-[#C9A45C]/15 mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid gap-12 md:grid-cols-12">
        <div className="md:col-span-4">
          <img src="/logo-nasdeal.jpg" alt="Logo NasDeal" className="h-28 w-28" />
          <p className="font-display text-2xl mt-4 text-[#F8F6F1]">Le luxe à portée de tous.</p>
          <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer"
            className="mt-6 inline-flex items-center gap-3 text-[#C9A45C] hover:text-[#E5C178] transition-colors" data-testid="footer-instagram-link" aria-label="Suivre NasDeal sur Instagram">
            <span className="h-11 w-11 border border-[#C9A45C]/50 flex items-center justify-center"><Instagram className="h-5 w-5" /></span>
            <span className="text-sm tracking-wider">{INSTAGRAM_HANDLE}</span>
          </a>
          <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer"
            className="mt-3 flex w-fit items-center gap-3 text-[#C9A45C] hover:text-[#E5C178] transition-colors" data-testid="footer-whatsapp-link" aria-label="Contacter NasDeal sur WhatsApp">
            <span className="h-11 w-11 border border-[#C9A45C]/50 flex items-center justify-center"><Phone className="h-5 w-5" /></span>
            <span className="text-sm tracking-wider">WhatsApp · {WHATSAPP_NUMBER}</span>
          </a>
        </div>
        <div className="md:col-span-3">
          <p className="eyebrow mb-5">Collections</p>
          <ul className="space-y-3">
            {cats.map((c) => (
              <li key={c.slug}><Link to={`/categorie/${c.slug}`} className="text-sm text-[#F8F6F1]/65 hover:text-[#C9A45C] transition-colors">{c.name}</Link></li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-2">
          <p className="eyebrow mb-5">La maison</p>
          <ul className="space-y-3 text-sm">
            <li><Link to="/a-propos" className="text-[#F8F6F1]/65 hover:text-[#C9A45C]" data-testid="footer-link-about">À propos de NasDeal</Link></li>
            <li><Link to="/contact" className="text-[#F8F6F1]/65 hover:text-[#C9A45C]" data-testid="footer-link-contact">Nous contacter</Link></li>
            <li><Link to="/marches" className="text-[#F8F6F1]/65 hover:text-[#C9A45C]" data-testid="footer-link-markets">Nos prochains marchés</Link></li>
            <li><Link to="/boutique" className="text-[#F8F6F1]/65 hover:text-[#C9A45C]">Boutique</Link></li>
          </ul>
        </div>
        <div className="md:col-span-3">
          <p className="eyebrow mb-5">Informations</p>
          <ul className="space-y-3 text-sm">
            {LEGAL.map(([to, label]) => (
              <li key={to}><Link to={to} className="text-[#F8F6F1]/65 hover:text-[#C9A45C]" data-testid={`footer-link-${to.slice(1)}`}>{label}</Link></li>
            ))}
          </ul>
        </div>
      </div>
      <div className="border-t border-[#C9A45C]/10">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-6 flex flex-col sm:flex-row gap-2 justify-between text-xs text-[#F8F6F1]/40">
          <p>© {new Date().getFullYear()} NasDeal. Tous droits réservés.</p>
          <p>Paiement sécurisé par Stripe · Aucune donnée bancaire stockée sur ce site</p>
        </div>
      </div>
    </footer>
  );
};
